import { Children, ReactElement } from 'react';
import { components as ReactSelectComponents, MenuListProps } from 'react-select';
import Flex from '@creditflowresearch/uilib/Flex';
import Checkbox from '@creditflowresearch/uilib/Checkbox';
import { Select, ISelectOption, GroupBase } from '@creditflowresearch/uilib/Select';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import useCurrencySection, { PINNED_CURRENCY_IDS }
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/Currency/useCurrencySection';
import {
  FilterSectionIds,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';

import styles from './currency.module.scss';

const MenuList = (props: MenuListProps<ISelectOption, true, GroupBase<ISelectOption>>) => {
  const items = Children.toArray(props.children) as ReactElement[];
  const pinned = items.slice(0, PINNED_CURRENCY_IDS.length);
  const rest = items.slice(PINNED_CURRENCY_IDS.length);

  return (
    <Flex direction='column'>
      <Flex direction='column' className={ styles.pinned }>{ pinned }</Flex>
      <ReactSelectComponents.MenuList { ...props }>
        { rest }
      </ReactSelectComponents.MenuList>
    </Flex>
  );
};

const Currency = () => {
  const {
    options,
    selectedValues,
    onChange,
    isExcludedEnabled,
    onChangeExclude,
  } = useCurrencySection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Currency }
      header={ (
        <FilterSectionHeader
          title="CURRENCY"
          rightSlot={ (
            <Checkbox
              checked={ isExcludedEnabled }
              onChange={ onChangeExclude }
              dataTest='currencyExcludedCheckbox'
              label="Exclude selected"
            />
        ) }
        />
      ) }
    >
      <Select
        isMulti
        options={ options }
        value={ selectedValues }
        onChange={ onChange }
        placeholder="Select a Currency"
        dataTest="currencySelect"
        closeMenuOnSelect={ false }
        hideSelectedOptions={ false }
        components={ { MenuList } }
        maxMenuHeight={ 300 }
        isNarrow
      />
    </FilterSection>
  );
};

export default Currency;
